
export default {
  name: 'CookiesStyler',
  data () {}
}
